import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './InformationContainer.module.scss';

interface InformationContainerProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
}

const InformationContainer = ({ children, title, className, ...restProps }: InformationContainerProps) => (
  <div {...restProps} className={classNames('bordered_container', className)}>
    <p className={classNames('subtitle_medium', styles.title)}>{title}</p>
    {children}
  </div>
);

export default InformationContainer;
